import { ImportProcessState } from "./enums";

namespace ImportProcessStateTypes {
  // This is here to make sure the namespace is not empty and the:
  //    "Cannot use 'export import' on a type or type-only namespace when the '--isolatedModules' flag is provided"
  // error is not thrown.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _ = 0;
  // ---

  export type Result = {
    errored: boolean;
    parsingErrors: boolean;
    parsingWarnings: boolean;
  };
  export namespace GET {
    export namespace Response {
      export interface Payload {
        id: string;
        modelId: string;
        status: ImportProcessState.Enums.Status;
        result: ImportProcessStateTypes.Result;
        createdAt: string;
        updatedAt: string;
      }
    }
  }
}

export default ImportProcessStateTypes;
